import { useState } from 'react'

import { EMPTY_LIST, EMPTY_OBJECT } from '../constants/common'
import { isValueObjectType } from '../utils/common'

export function useInlineNotifications(props) {
  const { initialNotifications = EMPTY_LIST } = props || EMPTY_OBJECT

  const [notifications, setNotifications] = useState(initialNotifications)

  function handleAddNotification(notification) {
    setNotifications(prev => [
      ...prev.filter(i => i.id !== notification.id),
      notification,
    ])
  }

  function handlePrependNotification(notification) {
    setNotifications(prev => [
      notification,
      ...prev.filter(i => i.id !== notification.id),
    ])
  }

  function handleRemoveNotification(notification) {
    const id = isValueObjectType(notification) ? notification.id : notification

    setNotifications(prev =>
      prev.some(i => i.id === id) ? prev.filter(i => i.id !== id) : prev
    )
  }

  return {
    handleAddNotification,
    handlePrependNotification,
    handleRemoveNotification,
    notifications,
  }
}
